import { utils } from "./common.js"

let API_ENV = utils.getCurrentApi()

let apiKeys = {}

if (API_ENV === 'local') {
  apiKeys = {
    accessKey: '0000000',
    secretKey: 'az5CAEUb0qsEAZRThvmp8FD8tawR8jrx',
    imageSecurityKey: 'vLZo4cqxmhA5klyWyXW5',
  }
}

if (API_ENV === 'dev') {
  apiKeys = {
    accessKey: '0000000',
    secretKey: 'az5CAEUb0qsEAZRThvmp8FD8tawR8jrx',
    imageSecurityKey: 'vLZo4cqxmhA5klyWyXW5',
  }
}

if (API_ENV === 'test') {
  apiKeys = {
    accessKey: '0000000',
    secretKey: 'az5CAEUb0qsEAZRThvmp8FD8tawR8jrx',
    imageSecurityKey: 'tqZcNGVyGdVPpQmrqzrD',
  }
}

if (API_ENV === 'prod') {
  apiKeys = {
    accessKey: '0000000',
    secretKey: 'az5CAEUb0qsEAZRThvmp8FD8tawR8jrx',
    imageSecurityKey: 'xjwXvByGleYjRZOuu5dO',
  }
}

export default apiKeys



// WEBPACK FOOTER //
// ./src/common/confing_key.js